// extracted by mini-css-extract-plugin
export var askAiIcon = "_ob-j";
export var category = "_ob-9";
export var categoryHeader = "_ob-e";
export var container = "_ob-0";
export var group = "_ob-a";
export var groupItems = "_ob-f";
export var groupSeparator = "_ob-k";
export var loading = "_ob-1";
export var noResults = "_ob-3";
export var placeholder = "_ob-2";
export var resultContent = "_ob-5";
export var resultIcon = "_ob-c";
export var resultItem = "_ob-g";
export var resultMeta = "_ob-8";
export var resultSubtitle = "_ob-7";
export var resultSuffix = "_ob-i";
export var resultTitle = "_ob-6";
export var resultsList = "_ob-4";
export var searchGroup = "_ob-d";
export var selected = "_ob-h";
export var subgroup = "_ob-b";